const debug = window?.app?.config?.debug
export { debug }
